import React from 'react';
import { Section } from './Section';
import { XCircle } from 'lucide-react';
export function CorePain() {
  const pains = ['No saber qué plataforma o estructura elegir', 'Miedo a invertir mal y tener que rehacer todo en seis meses', 'Depender demasiado de WhatsApp o Instagram para vender', 'No tener catálogo, pagos, despacho y medición ordenados', 'No saber si el negocio está realmente listo para ecommerce', 'Querer verse profesional frente a clientes nuevos sin lograrlo', 'Tener una tienda online que existe pero no vende'];
  return <section className="relative py-16 md:py-24 bg-navy-950 text-white overflow-hidden border-y border-white/5" data-id="element-38">
      {/* Cyan radial glow background */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-950 to-navy-950" data-id="element-39"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/10 blur-[150px] rounded-full" data-id="element-40"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <span className="text-accent font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-43">
            El problema real
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-44">
            El problema no es no tener una tienda online.{' '}
            <span className="text-accent" data-id="element-45">El problema es partir mal.</span>
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed" data-id="element-46">
            Muchos dueños de pymes retail toman la decisión de vender online y
            empiezan comprando una plantilla, un freelancer barato o un pack
            genérico de agencia. El resultado: una tienda que existe, pero que
            no funciona como canal de ventas. Sin estructura, sin conversión,
            sin medición y, en pocos meses, hay que rehacer todo.
          </p>
        </div>

        <div className="bg-navy-900/60 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-accent/20 shadow-glow" data-id="element-47">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5" data-id="element-48">
            {pains.map((pain, i) => <div key={i} className="flex items-start gap-3" data-id="element-49">
                <XCircle className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-50" />
                <span className="text-slate-300 font-medium" data-id="element-51">{pain}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}